import { ProjectOrGoalStatusPhase } from '@townsquare/status-summary/types';

export const isStatusFilterValid = (newStatus: string) => {
	return Object.values(ProjectOrGoalStatusPhase).findIndex(s => s === newStatus) !== -1;
};
